import React, { Component } from 'react';

class Tabs extends Component {
  render() {
    return (
      <div className="nav-tabs-custom">
        <ul className="nav nav-tabs">
          {
            this.props.children.map((child, key) => {
              return (
                <li key={key} className={child.props.active ? 'active' : ''}>
                  <a href={'#tabPane' + this.props.parentKey + '_' + key} data-toggle="tab" aria-expanded={child.props.active ? 'true' : 'false'}><b>{child.props.label}</b></a>
                </li>
              );
            })
          }
        </ul>
        <div className="tab-content">
          {
            this.props.children.map((child, key) => {
              return (
                <div key={key} className={'tab-pane' + (child.props.active ? ' active': '')} id={'tabPane' + this.props.parentKey + '_' + key}>
                  {child}
                </div>
              );
            })
          }
        </div>
      </div >
    );
  }
}

export default Tabs;


// WEBPACK FOOTER //
// ./src/modulos/componentes/Tabs.js